<template>
  <b-card>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      :opacity="0.6"
      rounded="sm"
    >
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col cols="12">
              <validation-provider #default="validationContext" name="Model">
                <b-form-group label="公司" label-for="user_id">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="userOptions"
                    label="name"
                    class="w-100"
                    :reduce="(val) => val.id"
                    v-model="user_id"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
          <!--     <b-form-group label="Search HKTV Mall 產品" label-for="search_keyword">
                <div class="d-flex align-items-center">
                  <b-form-input id="search_keyword" v-model="search_keyword" />
                  <b-button
                    variant="primary"
                    class="text-nowrap ml-2"
                    :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                    @click="handleSearch"
                  >
                    Search
                  </b-button>
                </div>
              </b-form-group> -->
              <b-form-group label="HKTV Mall 產品列表連結" label-for="url">
                <div class="d-flex align-items-center">
                  <b-form-input id="url" v-model="temp_url" />
                  <b-button
                    variant="primary"
                    class="text-nowrap ml-2"
                    :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                    @click="handleFetchURLData"
                  >
                    Get Information
                  </b-button>
                </div>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="3" lg-="2" v-for="(product, index) in products" :key="`product_${index}`" class="product">
                <b-card :class="`product-card ${product.selected?'selected':''}`" @click="selectProduct(product)">
                  <b-card-img
                    v-if="product.image"
                    :src="product.image"
                    alt="Card image"
                    class="b-card-img"
                  />
                  <b-card-body class="product-card-body">
                    <h4 class="card-title">{{ product.name }}</h4>
                    <h4 class="card-text" v-if="product.price">${{ product.price }}</h4>
                </b-card-body>
                <div v-if="product.selected" class="product-selected-tag">Selected</div>
                </b-card>
            </b-col>
          </b-row>
          <div class="mt-2">
            <template v-if="products.length > 0">
              <b-button
                variant="primary"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                type="submit"
              >
                提交
              </b-button>
              <b-button
                variant="outline-secondary"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                @click="resetData"
              >
                重設
              </b-button>
            </template>
            <b-button
              variant="outline-secondary"
              class="mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="hide"
            >
              返回產品頁
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BButton,
  BFormCheckbox,
  BFormInvalidFeedback,
  BOverlay,
  BFormTextarea,
  BCard,
  BCardBody,
  BCardImg,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, onMounted, onUnmounted } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, alphaNum, email } from "@validations";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import productStoreModule from "../productStoreModule";

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardBody,
    BCardImg,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    flatPickr,
    BFormInput,
    vSelect,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    BOverlay,
    BFormTextarea,
    quillEditor,
  },
  data() {
    return {
      user_id: null,
      search_keyword: "",
      link: "https://www.hktvmall.com/hktv/zh/search_a?keyword=",
      temp_url:
        "https://www.hktvmall.com/hktv/zh/search_a?keyword=toy&bannerCategory=AA87420000000&category=AA99800000000",
      loading: false,
    };
  },
  methods: {
    onSubmit(){
        if(!this.user_id)
        {
            this.$swal({
                title: "請選擇公司",
                icon: "error",
                customClass: {
                    confirmButton: "btn btn-primary",
                },
            });
            return;
        }
        let submitData = this.products.filter((product) => product.selected);

        if(submitData.length == 0)
        {
            this.$swal({
                title: "請選擇最少一樣產品",
                icon: "error",
                customClass: {
                    confirmButton: "btn btn-primary",
                },
            });
            return;
        }

        this.$swal({
        title: '確定提交?',
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("app-product/addProductFromHktv",{user_id: this.user_id, products: submitData})
            .then(response => {
              this.products = [];
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            })
            .catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            })
            .finally(() => {
              this.loading = false;
            });






        }
        






      });
    },
    hide() {
      this.$router.replace("/products");
    },
    selectProduct(product) {
      product.selected = !product.selected;
      if(product.category_link != product.link && product.selected){
        this.temp_url = product.category_link;
      }
    },
    handleSearch(){
      this.loading = true;
      this.$store
        .dispatch("app-product/fetchHKTVCategoryData", {
          url: this.link+this.search_keyword,
        })
        .then((response) => {
          this.products = response.data.products;
          this.temp_url = '';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleFetchURLData() {
      this.loading = true;
      this.$store
        .dispatch("app-product/fetchHKTVCategoryData", {
          url: this.temp_url,
        })
        .then((response) => {
          this.products = response.data.products;
          this.temp_url = '';
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-product";
    const userOptions = ref([]);
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, productStoreModule);

    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    onMounted(() => {
      fetchOptions();
    });

    const products = ref([
      ]);
    const resetData = () => {
      products.value = [];
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetData);

    const fetchOptions = () => {
      store
        .dispatch("app/fetchOptions", {
          users: true,
        })
        .then((response) => {
          userOptions.value = response.data.users;
        })
        .catch(() => {
          console.log("Error fetching options");
        });
    };

    return {
      resetData,
      products,
      refFormObserver,
      getValidationState,
      resetForm,
      userOptions,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.product{
    padding: 10px;
}

.product-card{
  /* Adds margin around each card */
  display: flex;
  background: lightgrey;
  color:white;
  border-radius: 10px;
  flex-direction: column;
  overflow:hidden;
  justify-content: space-between; /* Distributes space inside the card */
  height: 100%; /* Ensures all cards take full available height */
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  border:1px solid lightgrey;
  position:relative;
  .card-body{
    padding: 0;
  }
  &-body{
    padding: 10px !important;
    
    h4, .card-text{
        color:white;
    }
  }
  cursor:pointer;
  opacity: 0.75;

  .product-selected-tag{
    position:absolute;
    background: #046473;
    top: 0px;
    width: 100%;
    padding: 5px;
    text-align:center;
  }
}

.product-card.selected{
    background: #046473;
    border: 1px solid #046473;
    opacity: 1;
}

.b-card-img {
  height: 200px; /* Fixed height for images */
  object-fit: cover; /* Ensures images cover the area nicely */
  width: 100%; /* Ensures image covers the width */
}

.b-card-body {
  flex-grow: 1; /* Allows the body to fill the space */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Aligns content inside the body */
}


</style>
